<script setup lang="ts">
import ToastRoot from '@fondof-ui/components/toast/ToastRoot.vue'
import type { HTMLAttributeClass } from '@fondof-ui/types'
import { ToastClose, ToastDescription } from 'radix-vue'

const props = defineProps<HTMLAttributeClass>()
</script>

<template>
  <ToastRoot
    v-slot="slotProps"
    :class="['flex w-full items-center whitespace-pre-wrap', props.class]"
  >
    <ToastDescription as-child>
      <div>
        <slot name="icon" />
      </div>

      <div class="flex-1">
        <slot v-bind="slotProps" />
      </div>
    </ToastDescription>
    <ToastClose>
      <slot name="close" />
    </ToastClose>
  </ToastRoot>
</template>
